export const columns = [
  {
    title: 'No',
    key: 'row_id',
    headerClassName: 'no-column',
  },
  {
    title: 'Published URL',
    key: 'url',
    headerClassName: 'url-column',
  },
  {
    title: 'Message from URI database',
    key: 'message',
    headerClassName: 'message-column',
  }
];